import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  settingsApplication: {
    id: 'idSettingsApplication',
    menuHeaderImages: null,
    fallingSnowflakes: false,
  },
};

const settingsApplicationSlice = createSlice({
  name: 'statistics',
  initialState,
  reducers: {
    addSettingsApplicationRedux(state, { payload }) {
      const { key, subKey, value } = payload;
      state[key][subKey] = value;
    },
    addAllSettingsApplicationRedux(state, { payload }) {
      state.settingsApplication = payload;
    },
  },
});

export const { addSettingsApplicationRedux, addAllSettingsApplicationRedux } =
  settingsApplicationSlice.actions;

export default settingsApplicationSlice.reducer;
